export const sendRudderAnalyticsIdToBlotout = () => {
  // Once per session send RudderStack anonymousId to Blotout
  const RSidWasSent = sessionStorage.getItem('rs_id_sent');

  if (!RSidWasSent && typeof window !== 'undefined' && window.edgetag) {
    window.edgetag('ready', () => {
      const rudderAnonymousId = window.rudderanalytics?.getAnonymousId?.();

      if (rudderAnonymousId) {
        window.edgetag('data', { RS_anonymous_id: rudderAnonymousId });
        sessionStorage.setItem('rs_id_sent', 'true');
      }
    });
  }
};
